module.exports = __webpack_public_path__ + "img/yellow.9d750c6a.svg";